import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_RED } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const Track13CRed = ({ state, workState, onLabelClick }) => (
	<g id="Track13CRed" transform="translate(1730.000000, 1190.000000)" className="track">
		<g id="line" transform="translate(0.118954, 0.898777)"
			 stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)} strokeLinecap="round"
			 strokeWidth={tracksWidth}>
			<path
				d="M39.1013478,142.09156 L40.0859845,141.644383 C49.1555674,137.525399 57.5588274,132.074427 65.0174635,125.471994 L98.0346982,96.2449268 C102.77424,92.049454 106.875551,87.1841912 110.208756,81.8032064 L160.881046,0 L160.881046,0"/>
			<line x1="0.207257635" y1="156.321972" x2="28.9691612" y2="146.524948"/>
			<TrackArrow
				transform="translate(26.187458, 147.274576) rotate(-202.000000) translate(-26.187458, -147.274576) "
				points="30.187458 155.274576 22.187458 147.274576 30.187458 139.274576"/>
		</g>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'Track13CRed')}
			coords="84.546875, 65.398777"
			text="13C"
			textCoordsX="7.71972656"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}
		/>
	</g>
);

Track13CRed.propTypes = trackPropTypes;

export default Track13CRed;
